<ol class="timeline" aria-label="Etapas da operação">
  @for (step of steps(); track step.stage; let last = $last) {
    <li
      class="timeline__item"
      [class.is-done]="step.progress === 'Done'"
      [class.is-skipped]="step.progress === 'Skipped'"
      [class.is-current]="step.progress === 'Current'"
      [class.is-upcoming]="step.progress === 'Upcoming'"
      [class.is-last]="last"
      [attr.aria-current]="step.progress === 'Current' ? 'step' : null"
      [attr.aria-label]="describe(step)">
      <span class="timeline__marker" aria-hidden="true">
        @if (step.progress === 'Done' || step.progress === 'Skipped') {
          <i class="pi pi-check"></i>
        }
      </span>
      <div class="timeline__content">
        <div class="timeline__heading">
          <strong>{{ step.label }}</strong>
          @if (step.progress === 'Current') {
            <span class="timeline__tag timeline__tag--current">Agora</span>
          } @else if (step.progress === 'Skipped') {
            <span class="timeline__tag">Dispensada</span>
          }
        </div>
        <p>{{ step.description }}</p>
      </div>
    </li>
  }
</ol>
